import React from 'react';

interface UpgradePromptProps {
  feature: string;
  description?: string;
  compact?: boolean;
}

const FEATURE_LABELS: Record<string, string> = {
  tensions: 'Tension Arterial',
  lloros: 'Registro de Lloros',
  reminders: 'Recordatorios',
  advanced_analytics: 'Estadisticas Avanzadas',
  export_data: 'Exportacion de Datos',
};

const PREMIUM_FEATURES = [
  'Dolores de cabeza ilimitados',
  'Tension arterial',
  'Registro de lloros',
  'Recordatorios personalizados',
  'Estadisticas avanzadas',
  'Exportacion de datos',
];

export const UpgradePrompt: React.FC<UpgradePromptProps> = ({ feature, description, compact }) => {
  const featureLabel = FEATURE_LABELS[feature] || feature;

  if (compact) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '8px 12px',
        background: 'var(--color-surface)',
        borderRadius: '8px',
        border: '1px solid var(--color-border)',
        fontSize: '13px',
        color: 'var(--color-text-secondary)',
      }}>
        <span style={{ fontSize: '16px' }}>&#x1F451;</span>
        <span><strong>{featureLabel}</strong> requiere Premium</span>
      </div>
    );
  }

  return (
    <div style={{
      padding: '24px',
      background: 'var(--color-surface)',
      borderRadius: '16px',
      border: '1px solid var(--color-border)',
      textAlign: 'center',
      maxWidth: '400px',
      margin: '20px auto',
    }}>
      <div style={{ fontSize: '40px', marginBottom: '12px' }}>&#x1F451;</div>
      <h3 style={{
        fontSize: '18px',
        fontWeight: 600,
        marginBottom: '8px',
        color: 'var(--color-text)',
      }}>
        Funcionalidad Premium
      </h3>
      <p style={{
        fontSize: '14px',
        color: 'var(--color-text-secondary)',
        marginBottom: '16px',
        lineHeight: 1.5,
      }}>
        {description || `${featureLabel} esta disponible en el plan Premium.`}
      </p>
      <div style={{
        textAlign: 'left',
        marginBottom: '20px',
        padding: '12px 16px',
        background: 'var(--color-bg)',
        borderRadius: '10px',
      }}>
        <p style={{
          fontSize: '13px',
          fontWeight: 600,
          marginBottom: '8px',
          color: 'var(--color-text)',
        }}>
          Premium incluye:
        </p>
        {PREMIUM_FEATURES.map((f) => (
          <div key={f} style={{
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            fontSize: '13px',
            color: 'var(--color-text-secondary)',
            padding: '3px 0',
          }}>
            <span style={{ color: '#10b981' }}>&#x2713;</span> {f}
          </div>
        ))}
      </div>
      <div style={{
        padding: '12px',
        background: 'linear-gradient(135deg, #8b5cf6, #6366f1)',
        borderRadius: '10px',
        color: 'white',
        fontSize: '14px',
        fontWeight: 500,
      }}>
        4.99 EUR/mes
      </div>
      <p style={{
        fontSize: '12px',
        color: 'var(--color-text-secondary)',
        marginTop: '12px',
      }}>
        Contacta al administrador para activar Premium
      </p>
    </div>
  );
};
